module.exports = __webpack_public_path__ + "img/Studio-icon-01.a0a6a678.svg";